<template>
  <div style="clear: both">
    <!-- implemented ready to close (close)-->
    <template v-if="isChangeFullyImplemented && isCloser">
      <v-dialog v-model="closeDialog" persistent max-width="600px">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn dark v-bind="activatorProps" color="success" class="ma-2" :disabled="!allTasksComplete">{{ $t('Close') }}</v-btn>
        </template>
        <v-card>
          <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
          <v-card-text class="text-h6 font-weight-bold">
            {{ $t('Notification_ChangeConfirmedSatisfactorily') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="card-button" @click="closeDialog = false">{{ $t('No') }}</v-btn>
            <v-btn color="primary" text class="card-button" @click="close()">{{ $t('Yes') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- implemented ready to close (not ready to close) -->
    <template v-if="isChangeFullyImplemented && isCloser">
      <v-dialog v-model="notReadyToCloseDialog" persistent max-width="600px">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn dark v-bind="activatorProps" color="accent" class="ma-2">
            <span style="color: white !important;">{{
                  $t('Not_Ready_To_Close')}}</span>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
          <v-card-text class="text-h6 font-weight-bold">
            {{ $t('Notification_ChangeNotSatisfactorily') }}
          </v-card-text>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-form ref="closerDeniedReasonMo" v-model="valid" autocomplete="off">
                    <v-textarea
                      v-model="closerDeniedReason"
                      name="closerDenied"
                      variant="underlined"
                      :rules="closerDeniedReasonRules"
                      :label="$t('Prompt_ActionsNotCompletedSatisfactorily')"
                      auto-grow
                    ></v-textarea>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="card-button" @click="notReadyToCloseDialog = false">{{ $t('Cancel') }}</v-btn>
            <v-btn color="primary" text class="card-button" @click="submitCloserDenied()" :disabled="!valid">{{
              $t('Return_MOC_To_Coordinator')
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { FormStatus } from '@/common'
import MOCService from '@/services/moc.service'
import TaskService from '@/services/task.service'
import { AdvanceType } from '@/common/systemTypes'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
export default {
  name: 'CloserActions',
  data: () => ({
    isSaving: false,
    valid: false,
    closeDialog: false,
    closerDeniedReason: '',
    notReadyToCloseDialog: false,
    allTasksComplete: false
  }),
  props: {
    moc: {
      type: Object
    },
    role: {
      type: String
    }
  },
  components: {
    Toaster,
    LoadingDialog
  },
  computed: {
    closerDeniedReasonRules: {
      get: function () {
        return [(v) => !!v || this.$t('Rule_Required'), (v) => (v && v.trim().length >= 1) || this.$t('Rule_Required')]
      }
    },
    isCloser: function () {
      return this.moc.communityData.closers.includes(this.role)
    },
    isChangeFullyImplemented: function () {
      return this.moc.status.value === FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED].value
    }
  },
  methods: {
    close: function () {
      let mocid = this.moc.mocId
      this.$refs.loadingDialog.show()
      MOCService.close(mocid)
        .then(() => {
          this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_OwnerClosed') })
        })
        .catch((e) => {
          this.$refs.loadingDialog.error({
            metadata: 'close',
            error: e,
            message: this.$t('Error_Close')
          })
        })
    },
    submitCloserDenied: function () {
      if (!this.isSaving) {
        this.isSaving = true
        this.moc.closerDeniedReason = {
          reason: this.closerDeniedReason,
          closerDeniedBy: this.user
        }
        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.REVISION)
          .then((result) => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_CloserDeniedSaved') })
          })
          .catch((e) => {
            this.$refs.loadingDialog.error({
              metadata: 'submitCloserDenied',
              error: e,
              message: this.$t('Error_Close')
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    }
  },
  mounted() {
    TaskService.areAllTasksComplete(this.moc.mocId)
      .then((result) => {
        this.allTasksComplete = result
      })
      .catch((e) => {
        this.$refs.loadingDialog.error({
          metadata: 'allTasksComplete',
          error: e,
          message: this.$t('Error_Close')
        })
      })
  }
}
</script>

<style scoped></style>
